<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">

html,
body {
  scrollbar-width: none;
  .ods-scrollbar--main-content {
    height: calc(100vh - #{$--header-height});
    padding: var(--main-padding);
    background: var(--main-background);
    &.has-top-bar {
      height: calc(100vh - #{$--header-height} - #{$--header-topbar});
    }
  }
  #content browser {
 margin-right: -14px !important;
 overflow-y: scroll !important;
 overflow-x: hidden !important;
}
  .ods-scrollbar__bar.is-horizontal {
    height: 6px;
    left: 2px;
}
.ods-button.is-circle>span {
  color: var(--color-bg-interactive);
}
.ods-button--neutral:hover {
  background-color: var(--color-bg-hover-2) !important;
}
.ods-button.is-circle>[class*=ods-icon-]:active, .ods-button.is-circle>i:active,
.ods-button.is-circle>[class*=ods-icon-]:hover, .ods-button.is-circle>i:hover
 {
  background-color: var(--color-bg-interactive-soft) !important;
  border-color: var(--color-bg-interactive-soft) !important;
}
.ods-tooltip.coloricon.ods-icon-send{
  color: var(--color-bg-interactive);
}
::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
}
.ods-button:active, .ods-button:hover {
    background-color: var(--color-bg-interactive-soft);
}
.ods-table .cell {
  .ods-button:active, .ods-button:hover, .ods-button:focus {
        background-color: transparent;
        color: var(--color-bg-interactive) !important;
  }
}
.ods-main-nav .sub-menu__li.active .router-link-active .ods-main-nav__item-text {
    color: var(--color-bg-interactive) !important;
}
li .ods-button--neutral:hover {
    background-color: var(--color-bg-hover-2);
    border-color: var(--color-bg-hover-2);
}
.button-collapse {
  margin-bottom: 10px;
}
.button-collapse-withmargin {
  margin-bottom: 10px;
}
  .ods-table__body-wrapper {
    margin-bottom: 0px !important;
  }

  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  .ods-scrollbar__bar.is-vertical {
    z-index: 9999;
  }
  .ods-button.ods-button--neutral {
    color: var(--color-bg-interactive)
  }
  .ods-input__inner {
    background-color: var(--color-bg-hover-2) !important;
  }
  .ods-textarea__inner {
    background-color: var(--color-bg-hover-2) !important;
  }
  .ods-date-table td.end-date span, .ods-date-table td.start-date span, .ods-date-table td.current span {
    background-color: var(--color-bg-interactive) !important;
  }
  .ods-date-table td.available:not(.end-date):hover span, .ods-date-table td.available:not(.start-date):hover span,
  .ods-date-table td.current:not(.disabled):hover span,
  .ods-date-table td.in-range:hover, .ods-date-table td.in-range:active,
  .ods-date-table td.in-range:focus, .ods-date-table td.current:hover, .ods-date-table td.current:active,
  .ods-date-table td.current:focus   {
    background-color: var(--color-bg-interactive-soft);
  }
  .ods-menu--vertical.ods-menu--fixed.ods-menu--collapsed.ods-menu--true.ods-menu--submenu {
    box-shadow: 0px 0px 20px 0px #060e1414;
    a {
      color: var(--color-bg-interactive);
    }
  }
  .ods-button--neutral:active {
    background-color: transparent;
  }
  .ods-dropdown:after {
   color: transparent !important;
   background-color: transparent;
  }
  .ods-dropdown__icon {
    padding-top: 5px;
    font-size: 1.3rem;
    color: var(--color-txt-secondary) !important;
    background-color: transparent;
}
  .ods-dropdown--active:not(.ods-dropdown--hover) {
    color: var(--color-icon-interactive);
    background-color: transparent;
}
.ods-date-range-picker .ods-picker-panel__content {
    margin: 0;
    width: 324px;
}
.ods-month-table {
    padding: 13px;
}
.ods-date-table td {
  width: 3rem;
  height: 2.5rem;
}
.ods-picker-panel__content {
  width: 324px;
}
.ods-loading-spinner .undeterminated .track {
  stroke: var(--color-bg-interactive);
}
.b2b-filters__area {
    flex-direction: row !important;
}
}
</style>
